export default defineAppConfig({
    ui: {
        colors: {
            primary: 'indigo',
            neutral: 'zinc'
        },
        avatar: {
            variants: {
              size: {
                '4xl': {root: 'h-24 w-24 text-4xl'},
                '5xl': {root: 'h-32 w-32 text-5xl'},
                '6xl': {root: 'h-40 w-40 text-6xl'},
              }
            }
        },
        prose: {
            h1: {
                slots: {
                    leading: 'hidden p-0',
                    leadingIcon: 'hidden',
                }
            },
            h2: {
                slots: {
                    leading: 'hidden p-0',
                    leadingIcon: 'hidden',
                }
            },
            h3: {
                slots: {
                    leading: 'hidden p-0',
                    leadingIcon: 'hidden',
                }
            },
            h4: {
                slots: {
                    leading: 'hidden p-0',
                    leadingIcon: 'hidden',
                }
            },
            h5: {
                slots: {
                    leading: 'hidden p-0',
                    leadingIcon: 'hidden',
                }
            },
            h6: {
                slots: {
                    leading: 'hidden p-0',
                    leadingIcon: 'hidden',
                }
            },
        },
        icons: {
            arrowDown: 'i-ph-arrow-down',
            arrowLeft: 'i-ph-arrow-left',
            arrowRight: 'i-ph-arrow-right',
            arrowUp: 'i-ph-arrow-up',
            caution: 'i-ph-warning-circle',
            check: 'i-ph-check',
            chevronDoubleLeft: 'i-ph-caret-double-left',
            chevronDoubleRight: 'i-ph-caret-double-right',
            chevronDown: 'i-ph-caret-down',
            chevronLeft: 'i-ph-caret-left',
            chevronRight: 'i-ph-caret-right',
            chevronUp: 'i-ph-caret-up',
            close: 'i-ph-x',
            copy: 'i-ph-copy',
            copyCheck: 'i-ph-check-circle',
            dark: 'i-ph-moon',
            drag: 'i-ph-dots-six-vertical',
            ellipsis: 'i-ph-dots-three',
            error: 'i-ph-x-circle',
            external: 'i-ph-arrow-up-right',
            eye: 'i-ph-eye',
            eyeOff: 'i-ph-eye-slash',
            file: 'i-ph-file',
            folder: 'i-ph-folder',
            folderOpen: 'i-ph-folder-open',
            hash: 'i-ph-hash',
            info: 'i-ph-info',
            light: 'i-ph-sun',
            loading: 'i-ph-circle-notch',
            menu: 'i-ph-list',
            minus: 'i-ph-minus',
            panelClose: 'i-ph-caret-left',
            panelOpen: 'i-ph-caret-right',
            plus: 'i-ph-plus',
            reload: 'i-ph-arrow-counter-clockwise',
            search: 'i-ph-magnifying-glass',
            stop: 'i-ph-square',
            success: 'i-ph-check-circle',
            system: 'i-ph-monitor',
            tip: 'i-ph-lightbulb',
            upload: 'i-ph-upload',
            warning: 'i-ph-warning'
        },
    },

    header: {
          links: [{
            label: 'Services pour',

            children: [{
              label: 'Association locale',
              description: 'Trouvez des bénévoles près de chez vous',
              to: '/association',
            }, {
              label: 'Siège d\'une association nationale',
              description: 'Accompagnez le bénévolat dans votre réseau',
              to: '/association/reseau',
            }, {
              label: 'Collectivité',
              description: 'Animez le tissu associatif de votre commune',
              to: '/collectivite',
            }, {
              label: 'Bénévole',
              description: 'Notre plateforme de bénévolat grand public',
              to: '/benevolt',
            }],
          }, {
            label: 'Solutions',

            children: [{
              label: 'Un outil centralisé pour gérer l\'engagement',
              description: 'Le pouvoir d\'un SaaS adapté aux associations',
              to: '/espace-asso',
            }, {
              label: 'Votre propre plateforme d\'engagement',
              description: 'Un site en marque blanche à vos couleurs',
              to: '/plateforme-engagement',
            }, {
              label: 'Organiser une collecte',
              description: 'Notre outil de mobilisation pour vous faciliter la vie',
              to: '/organiser-collecte',
            }, {
              label: 'Plus qu\'un outil',
              description: 'Notre équipe vous accompagne au quotidien',
              to: '/accompagnement',
            }, {
                label: 'Engagement : Cap sur le numérique',
                description: 'Une formation pour adapter vos pratiques aux nouvelles attentes des bénévoles',
                to: '/expertise-formation/engagement-numerique',
            }, {
                label: 'Expertise & formation',
                description: 'Accompagnez la transformation de votre association',
                to: '/expertise-formation',
            }],
          }, {
            label: 'Ressources',

            children: [{
              label: 'Les petites astuces',
              to: '/petites-astuces',
            }, {
              label: 'Blog - La fabrique associative',
              to: '/ressources',
            }, {
              label: 'Guide - Culture Bénévole',
              to: '/guides/association-culture-benevole',
            }, {
                label: 'Guide - Déléguer la coordination des bénévoles',
                to: '/guides/deleguer-coordination-benevole',
            }, {
              label: 'Guide - Gouvernance Associative - Tome 1',
              to: '/guides/gouvernance-associative-crise',
            }, {
              label: 'Guide - Gouvernance Associative - Tome 2',
              to: '/guides/gouvernance-associative-evolution',
            }, {
              label: 'Auto-diagnostic Gouvernance Associative',
              to: '/diagnostic-association',
            }, {
                label: 'Petit dej\' interassociatif',
                to: '/petit-dej-interassociatif',
            }, {
              label: 'Aide & FAQ',
              to: 'https://aide.benevolt.fr',
              external: true,
              target: '_blank',
            }],
          }],
      },

    footer: {
          links: [{
            label: 'Qui sommes-nous ?',

            children: [{
              label: 'À propos',
              to: '/a-propos',
              external: true,
            }, {
              label: 'Équipe',
              to: '/equipe',
            }, {
              label: 'Presse',
              to: '/presse',
            }, {
              label: 'Partenaires',
              to: '/partenariat',
            }],
          }, {
            label: 'Pour aller plus loin',

            children: [{
              label: 'Centre d\'aide',
              to: 'https://aide.benevolt.fr',
              target: '_blank',
              external: true,
            }, {
              label: 'Blog - La Fabrique associative',
              to: '/ressources',
            }, {
              label: 'Petites Astuces associatives',
              to: '/petites-astuces',
            }],
          }]
      },
})